import { render, staticRenderFns } from "./fillBlanks.vue?vue&type=template&id=e4fafb38&scoped=true"
import script from "./fillBlanks.vue?vue&type=script&lang=js"
export * from "./fillBlanks.vue?vue&type=script&lang=js"
import style0 from "./fillBlanks.vue?vue&type=style&index=0&id=e4fafb38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fafb38",
  null
  
)

export default component.exports